import { SelectDescType } from 'components/SelectWithDescriptions/SelectWithDescriptions';
import { EmployerOption } from 'hooks/webapi/foxentry/useCompaniesByIdMutation';
import { EmploymentStatus } from 'hooks/webapi/useClient';

export const areEmployerStepsRequired = (
  employmentTypeStatus?: EmploymentStatus,
): boolean =>
  ['EMPLOYEE', 'SELF_EMPLOYED'].includes(employmentTypeStatus || '');

export const parseEmploymentDetails = (
  employmentTypeStatus?: EmploymentStatus,
  profession?: SelectDescType,
) =>
  areEmployerStepsRequired(employmentTypeStatus)
    ? profession?.value
    : undefined;

export const getEmployerName = (
  value: string | EmployerOption | undefined,
): string => {
  return typeof value === 'string' ? value : value?.data?.name ?? '';
};
